import { UserComponent } from '@craftjs/core';
import { FormFieldWithOptionsProps, FormFieldWithScoreProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormRadioGroupInputProps = FormFieldWithOptionsProps &
  FormFieldWithScoreProps & {
    isVertical?: boolean;
  };

export const formRadioGroupInputDefaultProps: FormRadioGroupInputProps = {
  title: 'Radio group input',
  dataKey: createId(),
  options: [
    {
      key: createId(),
      value: 'Option 1',
    },
    {
      key: createId(),
      value: 'Option 2',
    },
  ],
};

export type FormRadioGroupInputComponent = UserComponent<FormRadioGroupInputProps>;
